import { render, staticRenderFns } from "./SorteioContainer.vue?vue&type=template&id=b3add86e&scoped=true"
import script from "./SorteioContainer.vue?vue&type=script&lang=js"
export * from "./SorteioContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3add86e",
  null
  
)

export default component.exports